module.exports = __webpack_public_path__ + "resources/img/equipment_tab4_img3_m.8175133cbf26426fab8963292636c63f.jpg";